module.exports = __webpack_public_path__ + "img/test-delect-active.ada3beef.svg";